<div class="delivery-charges-modal">
  <div class="sec_head">
    <h2>{{ 'ManageDeliveryCharges' | translate }}</h2>
  </div>
  <div class="modal-body">
    <form
      class="attribute-modal"
      [formGroup]="deliveryChargesForm"
      (ngSubmit)="onSubmit()">
      <div class="form_feilds gap_m">
        
        <!-- Toggle for Enable Custom Charges-->
        <div class="form_group w_100">
          <div class="toggle-container">
            <mat-label>{{ 'EnableCustomCharges' | translate }}</mat-label>
            <mat-slide-toggle
              formControlName="enableCustomCharges"
              (change)="onToggleChange($event)"
              color="primary">
            </mat-slide-toggle>
          </div>
        </div>

        <!-- Normal Delivery Charge Field -->
        <div class="form_group w_100" *ngIf="enableCustomCharges">
          <mat-label class="required">{{ 'NormalDeliveryCharge' | translate }}</mat-label>
          <mat-form-field appearance="fill">
            <input
              matInput
              type="number"
              formControlName="normalDeliveryCharge"
              placeholder="{{ 'NormalDeliveryCharge' | translate }}"
              class="form_control"
              min="0"
              step="0.01" />
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              deliveryChargesForm.controls['normalDeliveryCharge'].hasError('required')
            ">
            {{ 'NormalDeliveryCharge' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              submitted &&
              deliveryChargesForm.controls['normalDeliveryCharge'].hasError('min')
            ">
            {{ 'NormalDeliveryCharge' | translate }}
            {{ 'MustBePositive' | translate }}
          </mat-error>
        </div>

        <!-- Express Delivery Charge Field -->
        <div class="form_group w_100" *ngIf="enableCustomCharges">
          <mat-label class="required">{{ 'ExpressDeliveryCharge' | translate }}</mat-label>
          <mat-form-field appearance="fill">
            <input
              matInput
              type="number"
              formControlName="expressDeliveryCharge"
              placeholder="{{ 'ExpressDeliveryCharge' | translate }}"
              class="form_control"
              min="0"
              step="0.01" />
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              deliveryChargesForm.controls['expressDeliveryCharge'].hasError('required')
            ">
            {{ 'ExpressDeliveryCharge' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              submitted &&
              deliveryChargesForm.controls['expressDeliveryCharge'].hasError('min')
            ">
            {{ 'ExpressDeliveryCharge' | translate }}
            {{ 'MustBePositive' | translate }}
          </mat-error>
        </div>

      </div>
      <div class="submit_btn">
        <button type="submit" class="btnn btn_primary">
          {{ 'Submit' | translate }}
        </button>
      </div>
    </form>
  </div>
</div> 